module.exports = __webpack_public_path__ + "img/ic_tripadvisor-4.0.95674bd4.svg";